/**
 * Configuration resolver that prioritizes localStorage over window.ALGOLIA_CONFIG
 * Provides fallback mechanism and default values for missing configuration
 */

import { AlgoliaConstants } from './interfaces';

export class AlgoliaConfigResolver {
  private readonly constants: AlgoliaConstants;

  constructor() {
    this.constants = this.resolveConfiguration();
  }

  /**
   * Reads configuration from localStorage first, falls back to window.ALGOLIA_CONFIG, then defaults
   * @returns Resolved configuration constants
   */
  private resolveConfiguration(): AlgoliaConstants {
    return {
      aid: localStorage.getItem('aid') || (window as any).ALGOLIA_CONFIG?.appId || '',
      sak: localStorage.getItem('sak') || (window as any).ALGOLIA_CONFIG?.apiKey || '',
      productIndexStorage: localStorage.getItem('product_index') || (window as any).ALGOLIA_CONFIG?.indexName || 'apodiscounter_de_prod_productfeed'
    };
  }



  /**
   * Returns the complete configuration object
   * @returns Configuration constants
   */
  public getConstants(): AlgoliaConstants {
    return this.constants;
  }

  /**
   * Gets the product index name
   * @returns Product index name
   */
  public getProductIndex(): string {
    return this.constants.productIndexStorage;
  }

}